import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  emailChip: {
    backgroundColor: "#FFF0EF",
    "&:focus": {
      backgroundColor: "#FFF0EF",
    },
  },
  chipIcon: {
    fill: theme.palette.error.main,
  },
  label: {
    fontSize: "14px",
  },
}))

export default styles
